import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { MapMobileErrorState } from '../../../components/mobile'
import { Modal, Button } from 'react-bootstrap'
import { formatDateNoHours } from '../../../helpers/utils'
import ActivityMapMobileModalShell from '../../../components/mobile/ActivityMapMobileModalShell'

const InvalidDateRangeModal = ({
  show,
  handleClose,
  startDate,
  endDate: _endDate,
  username,
  isMobileLayout = false
}) => (
  <ActivityMapMobileModalShell
    show={show}
    onHide={handleClose}
    isMobileLayout={isMobileLayout}
    ariaLabelledBy="example-modal-sizes-title-lg"
    desktopDialogClassName="modal-90w close-button-modal-maps"
    mobileEyebrow="Mapa de geocercas"
    mobileTitle={
      <Typography className="activity-map-mobile-title">Reporte: {username || '-'}</Typography>
    }
    mobileFooterClassName="activity-map-mobile-footer geofence-map-mobile-footer"
    mobileBody={
      <Stack spacing={1.5}>
        <Box className="activity-map-mobile-info-card">
          <Box className="activity-map-mobile-info-grid">
            <Box className="activity-map-mobile-info-row">
              <Box sx={{ minWidth: 0 }}>
                <Typography className="activity-map-mobile-info-label">Usuario</Typography>
                <Typography className="activity-map-mobile-info-value">{username || '-'}</Typography>
              </Box>
            </Box>
            <Box className="activity-map-mobile-info-row">
              <Box sx={{ minWidth: 0 }}>
                <Typography className="activity-map-mobile-info-label">Fecha</Typography>
                <Typography className="activity-map-mobile-info-value">{formatDateNoHours(startDate)}</Typography>
              </Box>
            </Box>
          </Box>
          <Box className="activity-map-mobile-info-row">
            <Box sx={{ minWidth: 0 }}>
              <Typography className="activity-map-mobile-info-label">Hora de última actividad</Typography>
              <Typography className="activity-map-mobile-info-value">-</Typography>
            </Box>
          </Box>
        </Box>

        <Box className="activity-map-mobile-map-card">
          <MapMobileErrorState
            messages={[
              'No se puede mostrar un rango de fechas personalizado en el mapa de las geocercas.',
              'Por favor, elige un solo día para ver las visitas.'
            ]}
          />
        </Box>
      </Stack>
    }
    desktopChildren={
      <>
        <Modal.Header closeButton className="no-border-bottom">
          <Modal.Title id="example-modal-sizes-title-lg">
            <b className="mb-10">Mapa de Geocercas</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Header className="d-flex flex-column align-items-start">
          <p className="text-title-modal-map">Usuario: {username}</p>
          <p className="text-title-modal-map">Fecha: {formatDateNoHours(startDate)}</p>
          <p className="text-title-modal-map">Hora de última actividad: -</p>
        </Modal.Header>
        <Modal.Body>
          <div className="map-modal-error">
            <div className="map-error-label">
              <p>No se puede mostrar un rango de fechas personalizado en el mapa de las geocercas.</p>
              <p>Por favor, elige un solo día para ver las visitas.</p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={handleClose} className="custom-close-button">
            Cerrar
          </Button>
        </Modal.Footer>
      </>
    }
  />
)

export default InvalidDateRangeModal
